import { useId } from "react";
import { Tooltip } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { NavLink } from "react-router-dom";
import { AREAS_ENABLED } from "@superagents/types/api";
import { useSectorPermissions } from "@/core/auth/useSectorPermissions";
import { RoutePaths } from "@/core/constants/RoutePaths";
import styles from "./TeamTabs.module.css";

/** Mesma frase do item travado no menu (NavbarItem). */
const LOCKED_TAB_MESSAGE = "Você não tem acesso a essa funcionalidade";

// Classe em string, nunca a função do NavLink: o Tooltip do Mantine junta o
// `className` do filho com `cx()`, que descarta funções, e Áreas ficava sem
// estilo (link azul sublinhado). O estado ativo vem do `aria-current` no CSS.

/**
 * Abas da Equipe no topo da página (protótipo `teamTabs`). Cada aba é uma
 * rota: o bloqueio de Áreas (`ui:areas:view`) é do PermissionGate dela, então
 * a aba sem a chave continua visível e clicável, com o cadeado (SA-1352 D10).
 */
export function TeamTabs() {
  const { permissions, isLoading } = useSectorPermissions();
  const lockDescriptionId = useId();
  // Sem as permissões ainda não dá para saber: nada aparece travado.
  const areasLocked = !isLoading && !permissions.includes("ui:areas:view");

  return (
    <nav
      className={styles.tabs}
      aria-label="Equipe">
      <NavLink
        to={RoutePaths.TEAM_MANAGEMENT}
        end
        className={styles.tab}>
        Pessoas
      </NavLink>
      {AREAS_ENABLED && (
        <>
          <Tooltip
            label={LOCKED_TAB_MESSAGE}
            disabled={!areasLocked}
            withArrow>
            <NavLink
              to={RoutePaths.TEAM_MANAGEMENT_AREAS}
              className={styles.tab}
              data-locked={areasLocked ? "true" : undefined}
              aria-describedby={areasLocked ? lockDescriptionId : undefined}>
              Áreas
              {areasLocked && (
                <IconLock
                  size={13}
                  stroke={2.1}
                  aria-hidden
                />
              )}
            </NavLink>
          </Tooltip>
          {/* O tooltip só existe no hover; leitor de tela e teclado recebem o
              mesmo motivo pela descrição. */}
          {areasLocked && (
            <span
              id={lockDescriptionId}
              hidden>
              {LOCKED_TAB_MESSAGE}
            </span>
          )}
        </>
      )}
    </nav>
  );
}

export default TeamTabs;
